import { RouteLoader } from '@dofleini/security';
import React, { memo, Suspense } from 'react';

import PageLoader from '@/components/PageLoader';

import routesUserProposal from './routes-user-proposals';

const MainUserRouter = () => {
  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={routesUserProposal} notfoundRedirect={'/'}/>
    </Suspense>
  );
};
export default memo(MainUserRouter);
